import React, { useEffect } from "react";
import { wire } from "react-hot-wire";
import { WithTranslation, withTranslation } from "react-i18next";

import { Job } from "models/job/Job";
import { JobService } from "services/job/Job.service";
import { useQuery } from "@tanstack/react-query";
import { Table } from "../../../common/table/Table";
import { DrawerService } from "../../../../services/drawer/Drawer.service";
import { JobStateChip } from "../../common/JobStateChip";

export type ChildJobsProps = {
  job: Job;
  setApplicationState: Function;
  jobService: JobService;
  drawerService: DrawerService;
} & WithTranslation;

export const ChildJobs = ({
  job,
  setApplicationState,
  jobService,
  drawerService,
  t
}: ChildJobsProps) => {
  const i18nKey = "job.list";
  const query = useQuery(
    ["job", job.id],
    () => jobService.fetchJob({ id: job.id }),
    {
      refetchInterval: 5000
    }
  );

  useEffect(() => {
    if (query.data) {
      setApplicationState(query.data.state);
    }
  }, [setApplicationState, query.data]);

  return (
    <div className="modal-body overflow-auto" style={{ height: 0 }}>
      <div className="m-3">
        <Table
          title={t(`job.details.children.title`)}
          dataFetcher={() => jobService.fetchJobChildren({ id: job.id })}
          options={{
            search: false,
            pagination: false,
            disableCheckbox: true,
            refresh: 5000
          }}
          columns={[
            {
              field: "id",
              title: "",
              sorting: false,
              render: () => <></>
            },
            {
              field: "id",
              title: t(`${i18nKey}.column.id`),
              sorting: false
            },
            {
              field: "name",
              title: t(`${i18nKey}.column.name`),
              sorting: false
            },
            {
              field: "createdAt",
              title: t(`${i18nKey}.column.createdAt`),
              sorting: false,
              render: job => job.createdAt.format("DD.MM.YYYY H:mm:ss")
            },
            {
              field: "startedAt",
              title: t(`${i18nKey}.column.startedAt`),
              sorting: false,
              render: job =>
                job.startedAt
                  ? job.startedAt.format("DD.MM.YYYY H:mm:ss")
                  : "---"
            },
            {
              field: "finishedAt",
              title: t(`${i18nKey}.column.finishedAt`),
              sorting: false,
              render: job =>
                job.finishedAt
                  ? job.finishedAt.format("DD.MM.YYYY H:mm:ss")
                  : "---"
            },
            {
              field: "trigger",
              title: t(`${i18nKey}.column.trigger`),
              sorting: false
            },
            {
              field: "state",
              title: t(`${i18nKey}.column.state`),
              sorting: false,
              render: job => (
                <JobStateChip
                  job={job as Job}
                  onClick={() =>
                    drawerService.activate("preview-job", {
                      id: `preview-job-children-${job.id}`,
                      job
                    })
                  }
                />
              )
            }
          ]}
        />
      </div>
    </div>
  );
};

export default wire(
  ["jobService", "drawerService"],
  withTranslation()(ChildJobs)
);
